// src/composables/useToast.js
import { Toast } from 'bootstrap';

function getToastContainer() {
    let container = document.getElementById('app-toast-container');

    if (!container) {
        container = document.createElement('div');
        container.id = 'app-toast-container';
        container.className = 'toast-container position-fixed bottom-0 end-0 p-3';
        container.style.zIndex = '9999';
        document.body.appendChild(container);
    }

    return container;
}

export function useToast() {
    function showToast(message, options = {}) {


        let header = options.title ?? "Notificação";
        options.delay = options.delay ?? 5000
        options.autohide = options.autohide ?? true;
        options.type = options.type ?? ''

        let icon = ''
        let progressColor = 'bg-secondary'

        if (options.type == 'success') {
            icon  = '<i class="flaticon-check-mark-1 text-success me-2 text-lg"></i>'
            progressColor = 'bg-success'
        } else if (options.type == 'error') {
            icon  = '<i class="flaticon-close-1 text-danger me-2 text-lg"></i>'
            progressColor = 'bg-danger'
        } else if (options.type == 'warning') {
            icon  = '<i class="flaticon-warning text-warning me-2 text-lg"></i>'
            progressColor = 'bg-warning'
        }

        const showProgress = options.autohide

        // Crie um elemento div que irá conter o Toast
        const toastEl = document.createElement('div');
        toastEl.className = 'toast overflow-hidden';
        toastEl.role = 'alert';
        toastEl.ariaLive = 'assertive';
        toastEl.ariaAtomic = 'true';

        // Configurar o conteúdo do Toast
        toastEl.innerHTML = `
        <div class="toast-header">
            <strong class="me-auto">${header}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body d-flex align-items-center">
            ${icon}
            <span>${message}</span>
        </div>
        ${showProgress ? `<div class="toast-progress ${progressColor}" style="height:3px;width:100%;transition:width ${options.delay}ms linear"></div>` : ''}
        `;

        const container = getToastContainer();
        container.prepend(toastEl);

        const toast = new Toast(toastEl, options);
        toast.show();

        if (showProgress) {
            const progressBar = toastEl.querySelector('.toast-progress');
            requestAnimationFrame(() => {
                progressBar.style.width = '0%';
            });
        }

        toastEl.addEventListener('hidden.bs.toast', () => {
            toastEl.remove();
        });
    }

    return {
        showToast,
    };
}
